import React, { useContext, useLayoutEffect, useState } from "react";
import "./index.scss";
import { FaShoppingBasket } from "react-icons/fa"; // If you're using react-icons
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/userContext";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import ModalDisconnect from "../ModalDisconnect";
import ModalMenu from "../ModalMenu";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
    zIndex: 9,
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderWidth: 0.2,
    borderRadius: 12,

    background: "#fff",
  },
};
const customStylesMenu = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.45)",
    zIndex: 9999,
  },

  content: {
    top: "0",
    left: "0",
    right: "auto",
    bottom: "0",

    width: "320px", // desktop drawer width
    maxWidth: "85vw", // mobile width
    height: "100vh",

    padding: "0",
    border: "none",
    borderRadius: "0px",
    background: "white",

    boxShadow: "4px 0px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
function NavBar({ page }: any) {
  const { isAuthenticated,  searchQuery, setSearchQuery, user } =
    useContext(UserContext);
  const {  width } = useWindowDimensions();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDisConnect, setIsOpenDisconnect] = useState(false);

  const closeModal = () => {
    setIsOpenDisconnect(false);
  };

  const handleSearch = (event) => {
    // Handle the search logic here
    event.preventDefault();
    navigate("/shop");
    // Navigate or fetch search results based on searchQuery
  };
  const navigate = useNavigate();
  const productsInBasket = useSelector(
    (state: Storage) => state?.entities?.basketSlice?.product
  );

  const closeModalMenu = () => {
    setIsOpen(false);
  };
  return (
    <nav className="navbar" style={{ paddingLeft: 15, paddingRight: 15 }}>
      <div className="logo-and-basket-container">
        <div
          className="nav-logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/acceuil")}
        >
          Mhiri Store Phones
        </div>
        <div className="nav-basket" style={{ cursor: "pointer" }}>
          <i
            className="bx bx-basket"
            style={{ fontSize: 28, color: "#fd8555", marginTop: 10 }}
            onClick={() => navigate("/card")}
          ></i>
          {productsInBasket?.length > 0 && (
            <div className="basket-badge-container">
              <span className="basket-badge">{productsInBasket?.length}</span>
            </div>
          )}
        </div>
      </div>

      <div className="nav-search" style={width <= 768 ? { width: "100%" } : {}}>
        <form onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit">Search</button>
        </form>
        {width < 768 && (
          <i
            className="bx bx-menu"
            style={{ fontSize: 28 , color : "#fff" }}
            onClick={() => setIsOpen(true)}
          ></i>
        )}
      </div>

      <>
        {width > 768 ? (
          <div className="nav-buttons">
            {user?.role == 1 && (
              <button
                className="nav-button"
                onClick={() => navigate("/dashboard-admin")}
                style={{ backgroundColor: "#bee" }}
              >
                DashBoard
              </button>
            )}
            <button className="nav-button" onClick={() => navigate("/shop")}>
              Shop
            </button>
            {isAuthenticated && (
              <button
                className="nav-button"
                onClick={() => navigate("/profile")}
              >
                Profile
              </button>
            )}
            {isAuthenticated ? (
              <button
                onClick={() => setIsOpenDisconnect(true)}
                className="nav-button"
              >
                Logout
              </button>
            ) : (
              <button onClick={() => navigate("/login")} className="nav-button">
                Login
              </button>
            )}
          </div>
        ) : (
          <></>
        )}
      </>
      <Modal
        isOpen={isOpenDisConnect}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalDisconnect closeModalDisconnect={closeModal} />
      </Modal>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModalMenu}
        style={customStylesMenu}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalMenu
          setIsOpen={setIsOpen}
          setIsOpenDisconnect={setIsOpenDisconnect}
          page={page}
        />
      </Modal>
    </nav>
  );
}

export default NavBar;
